<template>
  <div class="ui one column grid">
    <div class="column">
      <table class="ui celled very compact table">
        <thead v-if="columns.length > 0">
          <tr>
            <th v-for="column in columns"
                :width="column.width"
                :classes="column.classes">
              {{ column.name }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="object in objects">
            <td :width="widths[0]">
              <div class="ui fluid transparent input">
                <input type="number"
                       :placeholder="placeholders.amount"
                       @input="preventNegativeNumber(object)"
                       v-model.number="object.amount">
              </div>
            </td>

            <td :width="widths[1]">
              <div class="ui fluid transparent input">
                <input type="text"
                       :placeholder="placeholders.description"
                       v-model="object.description">
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot class="full-width" v-if="objects.length > 0">
          <tr>
            <!-- <th :colspan="amountFooterColspan"></th> -->
            <th colspan="2">
              <span style="font-size:15px;">
                <strong>
                  {{ $t('totalSumation') }}
                  &#61;
                  £ {{ totalSumation() }}
                </strong>
              </span>
            </th>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    objectArray: {
      type: Array,
      required: true
    },
    placeholders: {
      type: Object,
      required: true
    },
    widths: {
      type: Array,
      default: () => { return [] }
    },
    columns: {
      type: Array,
      required: true
    },
    clearData: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      objects: [],
      isValidForm: true
    }
  },
  watch: {
    objects: {
      handler: function () {
        let lastObject = this.objects.length >= 1 ? this.objects[this.objects.length - 1] : null
        let beforeLastObject = this.objects.length > 1 ? this.objects[this.objects.length - 2] : null

        if (lastObject && (lastObject.description || lastObject.amount)) {
          this.addMultiObjects(1)
        }

        if (beforeLastObject && (!beforeLastObject.description && !beforeLastObject.amount)) {
          this.objects.splice(this.objects.length - 1, 1)
        }

        let returnedData = window._.cloneDeep(this.objects)
        returnedData.splice(returnedData.length - 1, 1)

        this.isValidForm = returnedData.every(object => {
          return object.description && object.amount
        }) || !returnedData.length

        this.$emit('onChange', {
          data: returnedData,
          dataSumation: this.totalSumation(),
          isValid: this.isValidForm
        })
      },
      deep: true
    },
    clearData: function () {
      if (this.clearData) {
        this.objects = []
        this.addMultiObjects(1)
      }
    }
  },
  mounted () {
    if (this.objects.length === 0) {
      this.objects = this.objectArray
    }
  },
  methods: {
    preventNegativeNumber (object) {
      if (object.amount < 0) {
        object.amount = Math.abs(object.amount)
      }
    },
    addMultiObjects (numberOfObjects) {
      for (var i = 0; i < numberOfObjects; ++i) {
        this.objects.push({
          amount: null,
          description: null
        })
      }
    },
    totalSumation () {
      return 0 + window._.sumBy(this.objects, object => {
        return object.amount
      })
    },
    noExtraIsFound () {
      return this.objects.length === 1 && (this.objects[0].amount === null || this.objects[0].amount === 0) &&
        (this.objects[0].description === null || this.objects[0].description === 0)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/abstract_components/MoneyForm.vue